import React, { Component } from 'react';
import { connect } from 'react-redux';
import FirstStep from './FirstStep';
import SecondStep from '../NuevaFichaVenta/SecondStep';
import ThirdStep from '../NuevaFichaVenta/ThirdStep';
import Modal from '../../../components/Modal';
import Steps from '../../../components/Steps';
import { searchProformas, clearProformasBuscar, fetchReglasNegocio, fetchEquiposLogisticaDetalle,fetchFichaVentaWelcomePackValidar,validateProforma,fetchWelcomePackValidar } from '../../../actions';


/*Inicio Req 93426 ebarboza 29 11 2021 */
const AlertWelcomePack = props =>{
  return (
    <div id="toast-container"
      style={{
        display: 'block', position: 'absolute', maxWidth: '350px', maxHeight: '350px',
        overflow: 'hidden', fontSize: '0.875rem', backgroundColor: 'rgba(248, 161, 74, 1)',
        backgroundClip: 'paddingBox', border: '2px solid rgba(0, 0, 0, 9)',
        boxShadow: 'rgb(248 161 74 / 10%) 0px 0.25rem 0.75rem', zIndex: '2000',
        backdropFilter: 'blur(10px)', opacity: '1', borderRadius: '0.65rem', top: '150px',
        left: '40%', width: '50%', height: '160px', color: 'white'
      }}>
      <div style={{ display: '-ms-flexbox', display: '-webkit-flex', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', justifyContent: 'center', alignContent: 'stretch', alignItems: 'flex-start' }}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <div style={{ fontSize: '16px', textAlign: 'center' }}>
            <h3>{props.titulo}</h3>
            <hr/>
            <strong>{props.numProfWelcomePack}</strong>
          </div>
        </div>
        <div style={{  width: '100%', display: 'flex', justifyContent: 'center', minHeight: '40px', overflow: 'hidden'}}>
          <div style={{alignSelf: 'center',fontSize: '14px'}}>
            {props.mensajeWelcomePack}
          </div>
        </div>
      </div>
    </div>
      
  )
}
/*Fin Req 93426 ebarboza 29 11 2021 */
const VACIO = '';
const VAR_REGLA_NEGOCIO = '06';
class AsignarProformas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      FirstStep: {
        selectedProform: [],
      },
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
      coloresProformaList:[],
      selectedProform: [],
      estadoTrama:'1',
      mensajeTrama:'',
      /*Inicio Req 93426 ebarboza 29 11 2021*/
      welcomePackProforma:[], 
      errorWelcomePack:false,
      estadoTramaWelcomePack:"",
      mensajeWelcomePack:"",
      numProfWelcomePack:"",
      proformasWelcomePack:[],
      isOpenModelGetWelcomePack:false,
      equipoAdicionalLocalList:[],
      selectEquipoWelcomePack:[],
      checkedWelcomePack: false,
      welcomePackMostrar:[]
    /*Fin Req 93426 ebarboza 29 11 2021*/
    };
  }

  selectProform = (proforma) => {

    const { selectedProform } = this.state;
    if (selectedProform.filter(({ nroProforma }) => nroProforma === proforma.nroProforma).length) {
      if (selectedProform.length === 1) {
        this.props.searchProformas(this.state.clientId);
        this.setState({ companyFilter: '', areaVentaFilter: '', selectedProform: [], vendedorId: '', vendedorName: '' });
      } else {
        this.setState({
          selectedProform: selectedProform
                            .filter(({ nroProforma }) => nroProforma !== proforma.nroProforma),
        });
      }
    } else {
      this.props.fetchEquiposLogisticaDetalle(proforma.nroProforma, VACIO, VACIO, 0, 0).then(entry =>{
        this.setState({
          selectedProform: [...this.state.selectedProform, Object.assign({},proforma,{'proformaDetail':entry.payload.data.dataVehiculo})],
        }, this.setProformas);

      })

    }
  }

  componentDidMount() {
    const { fdv } = this.props;
    this.props.searchProformas(fdv.codClie, null, fdv.codAreaVta, fdv.codCia, fdv.vendedor);
    this.props.fetchReglasNegocio(VACIO,VACIO,VACIO,VAR_REGLA_NEGOCIO);
  }

  fnSetSoloresProformaList = (coloresProformaList) =>{
    this.setState({coloresProformaList:coloresProformaList})

  }

  paginateProform = ({ selected }) => {
    const { fdv } = this.props;
    this.props.searchProformas(fdv.codClie, null, fdv.codAreaVta,
                                fdv.codCia, fdv.vendedor, selected + 1);
  }

  goToStep2 = (...object) => {
    this.setState({ FirstStep: object[0] });
    this.nextStep();
  }

  goToStep3 = (...object) => {
    this.setState({ SecondStep: object[0] });
    this.nextStep();
  }

  backToStep1 = () => {
    this.setState({
      SecondStep: {
        cardExpanded: [],
        condicionesProforma: '',
        capacitacionesProforma: '',
        usosProforma: '',
        coloresProforma: '',
      },
    });
    this.previousStep();
  }

  fnDefaultColorProforma = (proforma, index) => {
    const businessRolesList = this.props.reglasNegocio.businessRolesList;
    const proformas =  this.props.proformas.listConsultaProforma;
    if(businessRolesList.map(entry => {return entry.reglas}).indexOf( proformas.filter(entry => entry.nroProforma===proforma)[0].codAreaVta)>=0){
      return true;
    }
    return false;
  }

  fnLoadProformaColor = () => {
    const businessRolesList = this.props.reglasNegocio.businessRolesList;
    const proformas =  this.state.selectedProform;
    let coloresProformaList = [];
    proformas.forEach((proforma, index) => {
        if(this.fnDefaultColorProforma(proforma.nroProforma, index)){
          coloresProformaList=[...coloresProformaList,{[proforma.nroProforma]:[proforma.proformaDetail.codColorPintura+'---'+proforma.proformaDetail.colorPintura]}]
        }else{
          coloresProformaList=[...coloresProformaList,{[proforma.nroProforma]:['']}]
        }
      })

      this.setState({ coloresProformaList:coloresProformaList});
  }

  nextStep = () => {
    let checkedWelcomePack = this.state.checkedWelcomePack

    /*Inicio Req 93426 ebarboza 29 11 2021*/
    
    const welcomePackProforma = []
    if (this.state.step === 2){
      
       if(!this.crearAlertWelcomePack()){
          return
       }
     }
     if (this.state.step === 1){
      const proformas =  this.state.selectedProform;
      proformas.forEach((proforma, index) => {
        const promises = [];
        console.log(proforma);
        promises.push(this.props.fetchFichaVentaWelcomePackValidar(proforma.nroProforma));
        Promise.all(promises).then(result => {
          if(result[0].payload.data.estadoTrama==="0" && !checkedWelcomePack){
            welcomePackProforma.push(result[0])
            this.showAndHideAlertWelcPack(result[0]);
            this.setState({welcomePackProforma:welcomePackProforma,checkedWelcomePack:false})
          }else if(result[0].payload.data.estadoTrama==="1" && result[0].payload.data.codEquipo !=="" && result[0].payload.data.codEquipo !== null && result[0].payload.data.codEquipo !== undefined){
            const proformas = this.state.selectedProform;
            let proforma = []
            if (proformas !== null && proformas !== undefined) {
              proforma = proformas.filter(x => x.nroProforma === result[0].payload.data.numProfVeh)
            }
            this.props.fetchWelcomePackValidar(proforma[0]).then(resultEquipo => {
              if (resultEquipo.payload.data.estadoTrama === "1") {
                let welcomePackMostrar = []
                let equipoProforma = []
                if(resultEquipo.payload.data.cantidad > 0 && resultEquipo.payload.data.equipoAdicionalLocalList){
                  equipoProforma = resultEquipo.payload.data.equipoAdicionalLocalList.filter((equipo,index) => {return equipo.codEquipo === result[0].payload.data.codEquipo})
                  if(equipoProforma !== null && equipoProforma !== undefined ){
                  welcomePackMostrar.push(equipoProforma[0].codEquipo+"---"+equipoProforma[0].descEquipo)
                                  
                  }else{
                    welcomePackProforma.push(result[0])
                    this.showAndHideAlertWelcPack(result[0]);
                    this.setState({welcomePackProforma:welcomePackProforma,checkedWelcomePack:false})
                  }
                }
                this.setState({welcomePackMostrar: welcomePackMostrar, selectEquipoWelcomePack:equipoProforma})  
              }
            });
          }
         });
      });
     }
    /*Fin Req 93426 ebarboza 29 11 2021*/

    if (this.state.step +1  === 2) {
      this.fnLoadProformaColor();
    }
    this.setState({ step: this.state.step + 1 });
}
  previousStep = () => this.setState({ step: this.state.step - 1 })

   /*Inicio Req 93426 ebarboza 29 11 2021*/
   showAndHideAlertWelcPack = (result) => {
    if (result.payload.data.estadoTrama === "0") {
      this.setState({
        mensajeWelcomePack: result.payload.data.mensaje,
        numProfWelcomePack: "La Proforma: " + result.payload.data.numProfVeh
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);

    }
  };

  crearAlertWelcomePack = () => {
    const welcomePack = this.state.welcomePackProforma
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    let contador = 0
    if (selectEquipoWelcomePack.length > 0 && selectEquipoWelcomePack.length < 2) {
      return true
    }
    if (selectEquipoWelcomePack.length > 1) {
      this.setState({
        mensajeWelcomePack: "Welcome Pack",
        numProfWelcomePack: "Debe seleccionar un solo"
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
      return false
    }

    if (welcomePack !== null || welcomePack !== undefined) {
      welcomePack.map((x) => {
        if (x.payload.data.estadoTrama === "0") {
          contador++
          contador < 2 ?
            this.setState({
              mensajeWelcomePack: x.payload.data.mensaje,
              numProfWelcomePack: "La Proforma: " + x.payload.data.numProfVeh
            }) :
            this.setState({
              mensajeWelcomePack: x.payload.data.mensaje,
              numProfWelcomePack: "Mas de Una Proforma"
            })
          this.setState({ errorWelcomePack: true });
          setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
        }
      })
    }

    return contador >= 1 ? false : true
  }

  getFetchWelcomePack = (nroProforma, index) => {
    const proformas = this.state.selectedProform;
    let equipoAdicionalLocalList = this.state.equipoAdicionalLocalList
    let proforma = []
    if (proformas !== null && proformas !== undefined) {
      proforma = proformas.filter(x => x.nroProforma === nroProforma)
    }
    this.props.fetchWelcomePackValidar(proforma[0]).then(result => {
      console.log('fetchWelcomePackValidar: ', result)
      if (result.payload.data.estadoTrama === "1") {
        equipoAdicionalLocalList = result.payload.data.equipoAdicionalLocalList
        this.setState({ equipoAdicionalLocalList: equipoAdicionalLocalList })
        this.isOpenModelGetWelcomePack();
      }
    });
  }
  isOpenModelGetWelcomePack = () => {
    this.setState({ isOpenModelGetWelcomePack: this.state.isOpenModelGetWelcomePack ? false : true })
  }

  fnMostrarGridWelcomePack = () => {
    let equipoAdicionalLocalList = this.state.equipoAdicionalLocalList
    if (equipoAdicionalLocalList !== null && equipoAdicionalLocalList !== undefined) {
      if (equipoAdicionalLocalList.length) {
        return equipoAdicionalLocalList.map((equipoWelcomePack, index) => (
          <tr key={index}>
            <td style={{ width: "15%" }}>
              <div className='checkbox checkbox-inline'>
                <label>
                  <input key={equipoWelcomePack.codEquipo} name={equipoWelcomePack.codEquipo} type='checkbox' checked={this.state.selectEquipoWelcomePack.length > 0 ? this.state.selectEquipoWelcomePack.filter(x => x.codEquipo === equipoWelcomePack.codEquipo).length > 0 ? true : false : false}/>
                  <div className='checkbox-skin' onClick={() => this.selectWelcomePack(equipoWelcomePack)} />
                </label>
              </div>
            </td>
            <td style={{ width: "20%" }}>{equipoWelcomePack.codEquipo}</td>
            <td style={{ width: "65%" }}>{equipoWelcomePack.descEquipo}</td>
          </tr>
        ));
      }
      return <tr><td style={{ width: "100%" }} className='no-before' colSpan={12}>No hay resultados</td></tr>;
    }

  }
  selectWelcomePack = (equipoWelcomePack) => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    console.log("Seleccion:: ",...selectEquipoWelcomePack)
    let WelcomePack = []
    if (selectEquipoWelcomePack.filter(x => x.codEquipo === equipoWelcomePack.codEquipo).length > 0) {
     this.setState({selectEquipoWelcomePack:selectEquipoWelcomePack.filter(x => x.codEquipo !== equipoWelcomePack.codEquipo)})
    } else {
      this.setState({selectEquipoWelcomePack:[...selectEquipoWelcomePack,equipoWelcomePack]})
    }
}
  agregarWelcomePack = () => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    if (selectEquipoWelcomePack.length > 1) {
      this.setState({
        mensajeWelcomePack: "WELCOME PACK",
        numProfWelcomePack: "Solo debe seleccionar un"
      })
      this.setState({ errorWelcomePack: true });
      setTimeout(() => this.setState({ errorWelcomePack: false }), 1800);
      return false
    }else{
    let welcomePackMostrar = []
    selectEquipoWelcomePack.map(x => {welcomePackMostrar.push(x.codEquipo+"---"+x.descEquipo)})
    this.setState({welcomePackMostrar:welcomePackMostrar})
    }
    this.setState({ checkedWelcomePack: selectEquipoWelcomePack.length > 0 ? true : false })
    this.isOpenModelGetWelcomePack()
  }

  mostrarWelcomePack = () => {
    let selectEquipoWelcomePack = this.state.selectEquipoWelcomePack
    return (
      <table key={"mostrarWelcomePack"} class="table">
        <thead>
          <tr>
            <th key={"codigoEquipo"} scope="col">Codigo Welcome Pack</th>
            <th key={"descripcionEquipo"} scope="col">Descripción</th>
          </tr>
        </thead>
        <tbody>
          {selectEquipoWelcomePack.length > 0 ? selectEquipoWelcomePack.map((x, index) => {
            <tr>
              <td key={x.codEquipo + index}>{x.codEquipo}</td>
              <td key={x.codEquipo + index}>{x.descEquipo}</td>
            </tr>
          }) : null}
        </tbody>
      </table>
    )
  }
  /*Fin Req 93426 ebarboza 29 11 2021*/

  render() {
    const { proformas } = this.props;
    const { step,errorWelcomePack,checkedWelcomePack,selectEquipoWelcomePack,isOpenModelGetWelcomePack } = this.state;
    const stepsTitle = ['Asociar proforma', 'Condiciones de entrega', 'Confirmar'];

    return (
      <div>
        <Modal isOpen idModal='nueva-proforma' modalSize='modal-dialog modal-lg' title='Asociar nueva proforma' closeModal={this.props.closeModal}>
          <div className='modalBleed'>
            <Steps stepsTitle={stepsTitle} step={step} />
          </div>
          <div className='steps-container fdvNew-slides'>
            <ol className='breadcrumb breadcrumb-proform'>
              <li className='breadcrumb-item'>
                <div className='breadcrumb-item-content'>
                  <p className='breadcrumb-item-head'>Proforma(s) de:</p>
                  <p className='breadcrumb-item-title'>
                    {this.props.fdv.nomPerso}
                  </p>
                </div>
              </li>
            </ol>
            {
              step === 1 &&
                <FirstStep
                  proformas={proformas}
                  searchProformas={this.props.searchProformas}
                  fdv={this.props.fdv}
                  paginateProform={this.paginateProform}
                  nextStep={this.goToStep2}
                  {...this.state.FirstStep}
                  selectProform={this.selectProform}
                  selectedProform={this.state.selectedProform}
                />
            }
            {
              step === 2 &&
                <SecondStep
                  nextStep={this.goToStep3}
                  previousStep={this.backToStep1}
                  proformas={this.state.selectedProform}
                  codAreaVta={this.props.fdv.codAreaVta}
                  {...this.state.FirstStep}
                  {...this.state.SecondStep}
                  reglasNegocio={this.props.reglasNegocio}
                  fnDefaultColorProforma={this.fnDefaultColorProforma}
                  coloresProformaList={this.state.coloresProformaList}
                  fnSetSoloresProformaList={this.fnSetSoloresProformaList}
                  /*Inicio Req 93426 ebarboza 29 11 2021 */
                getFetchWelcomePack={this.getFetchWelcomePack}
                mostrarWelcomePack={this.mostrarWelcomePack}
                checkedWelcomePack={checkedWelcomePack}
                selectEquipoWelcomePack={selectEquipoWelcomePack}
                /*Fin Req 93426 ebarboza 29 11 2021 */
                />
            }
            {
              step === 3 &&
              <ThirdStep
                previousStep={this.previousStep}
                proformas={this.state.selectedProform}
                codAreaVta={this.props.fdv.codAreaVta}
                codCia={this.props.fdv.codCia}
                codCliente={this.props.fdv.codClie}
                codFilial={this.props.fdv.codFilial}
                codVendedor={this.props.fdv.vendedor}
                fdvID={this.props.fdv.numFichaVtaVeh}
                coloresProformaList={this.state.coloresProformaList}
                tipoComponente={1}
                {...this.state.SecondStep}
                /*Inicio Req 93426 ebarboza 29 11 2021 */
                selectEquipoWelcomePack={this.state.welcomePackMostrar}
                welcomePackEquipo={selectEquipoWelcomePack}
                /*Fin Req 93426 ebarboza 29 11 2021 */
              />
            }
          </div>
        </Modal>
        {/*Inicio Req 93426 ebarboza 29 11 2021 */
          errorWelcomePack && <AlertWelcomePack 
          titulo={'ALERTA WELCOME PACK'}
          mensajeWelcomePack={this.state.mensajeWelcomePack}
          numProfWelcomePack={this.state.numProfWelcomePack}
          />/*Fin Req 93426 ebarboza 29 11 2021 */
        }
        {/*Inicio Req 93426 ebarboza 29 11 2021 */}
        <Modal isOpen={isOpenModelGetWelcomePack} idModal='agregar-welcome-pack' modalSize='modal-dialog modal-lg' title='Welcome Pack' closeModal={this.isOpenModelGetWelcomePack}>
          <div className='modalBleed'>
            <table class="table table-dark">
              <thead>
                <tr>
                  <th style={{width:"15%"}} scope="col-2">Check</th>
                  <th style={{width:"20%"}} scope="col-3">Cod. Welcome Pack</th>
                  <th style={{width:"65%"}} scope="col-7">Descripción</th>
                </tr>
              </thead>
              <tbody>
              {this.fnMostrarGridWelcomePack()}
              </tbody>
            </table>
          </div>
          <div style={{display: 'flex', flexDirection: 'column', minHeight: '55px', justifyContent: 'center', alignItems: 'end'}}>
             <div>
             <button class="btn btn-primary open" onClick={()=>this.agregarWelcomePack()}>Guardar</button>
            </div>
          </div>
        </Modal>
        {/*Fin Req 93426 ebarboza 29 11 2021 */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    proformas: state.proformasBuscar,
    reglasNegocio: state.reglasNegocio,
  };
}

export default connect(mapStateToProps,
  {
    searchProformas,
    clearProformasBuscar,
    fetchReglasNegocio,
    fetchEquiposLogisticaDetalle,
    /*Inicio Req ebarboza 29 11 2021 */
    fetchFichaVentaWelcomePackValidar,
    validateProforma,
    fetchWelcomePackValidar
    /*Fin Req ebarboza 29 11 2021 */
  })(AsignarProformas);



// WEBPACK FOOTER //
// ./src/pages/modals/AsignarProformas/index.js